"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("underscore");
var PagerModel = /** @class */ (function () {
    function PagerModel(settings, onPageSelected, maxPageButtons) {
        var _this = this;
        if (maxPageButtons === void 0) { maxPageButtons = 10; }
        this.getPageButtons = function () {
            if (_this.lastPage <= 1)
                return [];
            if (_this.lastPage <= _this.maxPageButtons)
                return _.times(_this.lastPage, function (pageNumber) { return _this.buildPageButton(pageNumber + 1); });
            //Excluding the first, last and current buttons, count the 'spaces' available for page buttons
            var availableButtons = _this.maxPageButtons - 3;
            var availableButtonsAfter = Math.floor(availableButtons / 2);
            var pagesBetweenThisPageAndLast = _this.getPagesBetween(_this.page, _this.lastPage);
            if (availableButtonsAfter > pagesBetweenThisPageAndLast)
                availableButtonsAfter = pagesBetweenThisPageAndLast;
            var availableButtonsBefore = availableButtons - availableButtonsAfter;
            // if there are more pages between the current and first page than we can fit in the available spaces, ellipse
            var dotFront = _this.getPagesBetween(1, _this.page) > availableButtonsBefore;
            // if there are more pages between the current and last page than we can fit in the available spaces, ellipse
            var dotEnd = pagesBetweenThisPageAndLast > availableButtonsAfter;
            var indexOfSecondToLastButton = _this.maxPageButtons - 2;
            var pageNumberOfFirstMiddleButton = !dotFront ? 3 : _this.page - (availableButtonsBefore - 1); // the ellipsis takes up one of the available buttons, so adjust the first middle page number by + 1
            var middleButtonOffset = 0; //middle buttons start at the page number calculated above and then count up
            return _.times(_this.maxPageButtons, function (buttonIndex) {
                if (buttonIndex == 0)
                    return _this.buildPageButton(1);
                if (buttonIndex == 1)
                    return dotFront ? PagerPageButton.DottedPageButton() : _this.buildPageButton(2);
                if (buttonIndex < indexOfSecondToLastButton) {
                    var pageNumber = pageNumberOfFirstMiddleButton + middleButtonOffset++;
                    return _this.buildPageButton(pageNumber);
                }
                if (buttonIndex == indexOfSecondToLastButton)
                    return dotEnd ? PagerPageButton.DottedPageButton() : _this.buildPageButton(_this.lastPage - 1);
                return _this.buildPageButton(_this.lastPage);
            });
        };
        this.buildPageButton = function (pageNumber) {
            var isSelected = _this.page == pageNumber;
            return PagerPageButton.PageButton(pageNumber, isSelected);
        };
        this.goToPage = function (pageButton) {
            setTimeout(function () {
                if (pageButton.pageNumber) {
                    // TODO: The setTimeout here is a giant hack to work around the following problem: when showing a pager control from within the context of a flyout, clicking on one of the pager buttons
                    //       causes this function to get called, which updates the pager's buttons collection via the computable property above. This causes the old buttons (including the one you clicked) to 
                    //       get ripped out of the dom. But then when flyout receives the click event, the button is already removed from the dom, and flyout thinks you are clicking off of it, and (incorrectly)
                    //       closes. An alternative solution to this problem would be to make flyout.js treat clicks to elements outside of the dom as clicks "on" the flyout still.
                    _this.goToPageNumber(pageButton.pageNumber);
                }
            });
        };
        this.goToPageNumber = function (pageNumber) {
            _this.page = pageNumber;
            _this.pageSelectedHandler(pageNumber);
        };
        this.goToFirstPage = function () {
            if (!_this.previousPageEnabled)
                return;
            _this.goToPageNumber(1);
        };
        this.goToPreviousPage = function () {
            if (!_this.previousPageEnabled)
                return;
            _this.goToPageNumber(_this.page - 1);
        };
        this.goToNextPage = function () {
            if (!_this.nextPageEnabled)
                return;
            _this.goToPageNumber(_this.page + 1);
        };
        this.goToLastPage = function () {
            if (!_this.nextPageEnabled)
                return;
            _this.goToPageNumber(_this.lastPage);
        };
        if (maxPageButtons < 5)
            throw new Error("maxPageButtons must be >= 5 to account for first, current, last and possible ellipsis buttons");
        this.pageSelectedHandler = onPageSelected;
        this.maxPageButtons = maxPageButtons;
        this.firstPage = settings.firstPage;
        this.previousPageEnabled = settings.previousPageEnabled;
        this.page = settings.page;
        this.lastPage = settings.lastPage;
        this.nextPageEnabled = settings.nextPageEnabled;
        this.pageButtons = this.getPageButtons();
        this.visible = !!this.pageButtons.length;
    }
    PagerModel.prototype.getPagesBetween = function (firstPageNumber, secondPageNumber) {
        return Math.abs(firstPageNumber - secondPageNumber) - 1;
    };
    return PagerModel;
}());
exports.PagerModel = PagerModel;
var PagerPageButton = /** @class */ (function () {
    function PagerPageButton(options) {
        this.isDotted = !!options.isDotted;
        this.pageNumber = options.pageNumber;
        this.isSelected = !!options.isSelected;
        this.pageNumberDisplay = this.isDotted ? "..." : (this.pageNumber + "");
        this.enabled = !this.isDotted;
    }
    PagerPageButton.DottedPageButton = function () {
        return new PagerPageButton({ isDotted: true });
    };
    PagerPageButton.PageButton = function (pagerNumber, isSelected) {
        return new PagerPageButton({ pageNumber: pagerNumber, isSelected: isSelected });
    };
    return PagerPageButton;
}());
exports.PagerPageButton = PagerPageButton;
